import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["transition-opacity duration-300 lg:col-start-1 lg:row-start-1", { 'opacity-0': !_ctx.active }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}